module.exports = __webpack_public_path__ + "img/jpg-icon.d545db30.webp";